const NationalityVisa = () => {
    return (
    

    <div>
        
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Immigration Visa Applictions
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                    TCS Visatronix provides an ever wider choice of service locations which, for the applicants, 
                    adds to the ease of reaching a designated visa facilitation centre. This makes it easy for the 
                    applicants to apply for a visa category such as immigration visa that demands careful preparations 
                    at the applicant’s end.
                    </p>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Features such as queue management systems, dedicated visa lounges, faster document submission, 
                        form filling, documents scanning, faxing, emailing, photocopying and printing—all under one roof—makes 
                        it a breeze for visa applicants.
                    </p>
                  
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/visatronix/immigrationvisaapplications.jpg" alt="" className="rounded-md max-w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
}
export default NationalityVisa;